import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
    selector: 'text-loader',
    templateUrl: './text-loader.component.html',
    styleUrls: ['./text-loader.component.scss'],
    standalone: false
})
export class TextLoaderComponent implements OnInit, OnChanges, OnDestroy {

    @Input() interval: number = 1000;

    @Input() run: boolean = false;
    @Input() text: string;
    ticks: string = ""
    @Input() tickType: string = ".";
    timer: any;
    @Input() cycleLimit: number = -1;
    @Input() runObservable: Observable<boolean>;

    subscription: Subscription;

    constructor() { }

    ngOnInit() {
        if (this.runObservable != null) {
            this.subscription = this.runObservable.pipe(
                tap((res: boolean) => {
                    this.run = res;
                    if (this.run === true) {
                        this.ticks = this.tickType;
                        this.timer = setInterval(() => {
                            this.ticks = `${this.ticks}${this.tickType}`;
                            if (this.cycleLimit != -1 && this.ticks.length > this.cycleLimit) this.ticks = this.tickType;
                        }, this.interval);
                    }
                    else {
                        clearInterval(this.timer);
                    }
                })
            ).subscribe(
                () => { },
                (error) => { console.error(error); }
            );
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["run"]) {
            if (changes["run"].currentValue == true) {
                this.ticks = this.tickType;
                this.timer = setInterval(() => {
                    this.ticks = `${this.ticks}${this.tickType}`;
                    if (this.cycleLimit != -1 && this.ticks.length > this.cycleLimit) this.ticks = this.tickType;
                }, this.interval);
            } else {               
                clearInterval(this.timer);
            }                   
        }         
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }
}
